import './MyCart.scss'
import { Label, PrimaryButton, OutlineButton, Tooltip, Checkbox } from 'client/CommonComponents';
import { formatPrice } from 'utils';
import deleteItem from '../../../../assets/images/Delete 2 New.svg';
import { CONSTANTS } from "client/utils/constants";
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';
import CompleteConfirmationPopup from 'client/CommonComponents/DialogBox/CompleteConfirmationPopup';
import EventHandler from 'client/CommonComponents/EventHandler';
import permissions, { isAuthorized } from 'client/utils/Permissions';

const CartItems = (props: any) => {
  const { item, index, request, reasonCartList, type, renderVehicleDetails, getExpand, onClickDeleteReasonFromCart } = props
  
  const getPrice = (request: any, reasonItem: any) => {
    if(type === CONSTANTS.MANAGED_EQUIPMENT) {
      return (reasonItem?.quotePrice && reasonItem?.showQuotePrice) ? reasonItem?.estimatedPrice : (request?.price || request?.pricePerUnit)
    } else if(type === CONSTANTS.PRODUCTION_VEHICLE) {
      return (reasonItem?.estimatedPrice && reasonItem?.quotePrice) ? reasonItem?.estimatedPrice  : (request?.price || request?.pricePerUnit)
    } else if(type === CONSTANTS.NON_STANDARD_EQUIPMENT) {
      return (request?.price || request?.pricePerUnit)
    } else { 
      return (reasonItem?.quotePrice && reasonItem?.showQuotePrice) ?  reasonItem?.estimatedPrice : (request?.price  || request?.pricePerUnit)
    }
  }
  
  
  return <div className="details-container" id={index} key={index}>
    <div className="vehicle-details-section">
      {
        renderVehicleDetails(item.requestType, request, item)
      }
    </div>
    {getExpand(request) && reasonCartList &&
      reasonCartList.map((reasonItem: any, reasonIndex: any) => {
        if (request?.requestIndex === reasonItem?.requestIndex) {
          return (
            <div className="request-reason-section" key={reasonIndex}>
              <div className="item-price">
                <div className="title">Item # : {reasonCartList?.length - reasonIndex}</div>
                <div className="desc">{'$' + (formatPrice(getPrice(request, reasonItem), 2)) || 0.00}</div>
              </div>
              <div className="reason-block">
                <div className="left-block">
                  <div>
                    <Label data-attribute="MyCart_Default_Label_10">Reason :</Label> &nbsp;
                    <span>{reasonItem.reasonType}</span>
                  </div>
                  <div className='controls'>
                    <EventHandler onEvent={(e: any) => onClickDeleteReasonFromCart(e, reasonItem)} data-attribute={`MyCart_${(reasonItem?.reasonType || reasonIndex).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Delete_EventHandler`}>
                      <img src={deleteItem} className=" editImg me-1" alt="" />
                    </EventHandler>
                  </div>
                </div>
                <div className="right-block">
                  <div className="pull-left">
                    <Label data-attribute="MyCart_Default_Label_2_2">
                      {reasonItem?.reasonType == CONSTANTS.REASON_GROWTH
                        ? reasonItem?.newEmployeeBusiness == CONSTANTS.NEW_BUSINESS ? CONSTANTS.JOB_ID : CONSTANTS.EMP_ID
                        : CONSTANTS.REPLACED_ASSET}
                    </Label>
                    <p>
                      {reasonItem?.reasonType == CONSTANTS.REASON_GROWTH
                        ? (reasonItem?.jobIdOrEmpId || "-")
                        : reasonItem.asset}
                    </p>
                  </div>
                  {
                    reasonItem?.reasonType !== CONSTANTS.REASON_GROWTH ?
                      <div className="pull-left">
                        <Label data-attribute="MyCart_Default_Label_3_2">
                          {CONSTANTS.UNIT}
                        </Label>
                        <p>
                          {reasonItem?.unitNumber || "-"}
                        </p>
                      </div> : ""
                  }
                  <div className="pull-left">
                    <Label data-attribute="MyCart_Default_Label_4_2">
                      {reasonItem?.reasonType == CONSTANTS.REASON_GROWTH
                        ? reasonItem?.newEmployeeBusiness == CONSTANTS.NEW_BUSINESS ? CONSTANTS.JOB_NAME : CONSTANTS.EMP_NAME
                        : CONSTANTS.DESCRIPTION}
                    </Label>
                    <p>
                      {reasonItem?.reasonType == CONSTANTS.REASON_GROWTH
                        ? reasonItem?.jobOrEmpName
                        : reasonItem.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )
        }

      })}
  </div>
}

const MyCart = (props: any) => {
  const {
    requestTypeList,    
    productionCartVehicleList,
    nonStandardEquipmentCartList,
    managementVehicleCartList,
    reasonCartList,
    grandTotal,
    handleClickComplete,
    Popupcontent,
    cancelPopupcontent,
    hideDialog,
    hideDialogCancel,
    handleClickCancel,
    handleCollapseClick,
    onClickDeleteRequestFromCart,
    onClickDeleteReasonFromCart,
    handleClickSave,
    managedEquipmentCartList,
    isEditOrder,
    orderByIdValue,
    handleClickCheckbox,
    handleClickRequestToggle,
    requestExpand,
    getExpand,
    isCostCenterAvailableForSubmit
  } = props;

  const renderVehicleDetails = (type: any, request: any, item: any) => {
    const commonDivFunc = () => {
      return(
      <div className="right-block delete-type">
            <div className="up-down-image">
                <EventHandler onEvent={(e: any) => onClickDeleteRequestFromCart(e, request)} data-attribute="MyCart_Default_EventHandler_2_3">
                  <img
                      src={deleteItem}
                      alt="edit"
                      className=" editImg me-1"
                      title="Delete"
                  />
                </EventHandler>
            </div>
            <div className="up-down-image bg-color">
                <EventHandler onEvent={() => handleClickRequestToggle(request)} data-attribute="MyCart_Default_EventHandler_3_2">
                  <span className={'fa ' + (getExpand(request) ? 'fa-angle-up' : 'fa-angle-down')}></span>
                </EventHandler>
            </div>
          </div>
      )
    }
    if (type === CONSTANTS.PRODUCTION_VEHICLE) {
      return (
        <>
          <div className='vehicle-type production'>
            <div className="title">Vehicle</div>
            <div className="desc">{request?.vehicleType || "-"}</div>        
          </div>
          <div className='fuel-type'>
            <div className="title">Fuel Type</div>
            <div className="desc">{request?.fuelType || "-"}</div>
          </div>
          <div className='snow-setup'>{/*  UI need to fix */}
            <div className="title">Snow Setup</div>
            <div className="desc">{request?.snowSetup || "-"}</div>
          </div>
          <div className="right-block delete-type">
              <div className="up-down-image">
                  <EventHandler onEvent={(e: any) => onClickDeleteRequestFromCart(e, request)} data-attribute="MyCart_Default_EventHandler_4_2">
                    <img
                        src={deleteItem}
                        alt="edit"
                        className=" editImg me-1"
                        title="Delete"
                    />
                  </EventHandler>
              </div>
              <div className="up-down-image bg-color">
                  <EventHandler onEvent={() => handleClickRequestToggle(request)} data-attribute="MyCart_Default_EventHandler_5_2">
                    <span className={'fa ' + (getExpand(request) ? 'fa-angle-up' : 'fa-angle-down')}></span>
                  </EventHandler>
              </div>
          </div>
          {
            request?.showVehicleCapacity &&
            <div className='capacity-type'>
              <div className="title">Capacity</div>
              <div className="desc">{request?.vehicleCapacity || '-'}</div>
            </div>
          }
          <div className='door-type'>
            <div className="title"># of Doors</div>
            <div className="desc">{request?.doorNos || '-'}</div>
          </div>
          <div className='quantity-type'>
            <div className="title">Quantity</div>
            <div className="desc">{request?.quantity || '-'}</div>
          </div>
        </>
      )
    }
    if (type === CONSTANTS.MANAGEMENT_VEHICLE) {
      let driverDetails = request?.vehicleDriverDetails?.map((item: any) => item.employeeFullName).join(',');
      return (
        <>
          <div className='vehicle-type mangement-vehicle'>
            <div className="title">Driver Title</div>
            <div className="desc">{request?.driverTitle || "-"}</div>
          </div>
          <div className='fuel-type'>
            <div className="title">Fuel Type</div>
            <div className="desc">{request?.fuelType || "-"}</div>
          </div>
          {commonDivFunc()}
          <div className='capacity-type driverdetails'>
            <div className="title">Driver Details</div>
            <Tooltip content={driverDetails || "-"} data-attribute="MyCart_Default_Tooltip">
            <div className="desc">{driverDetails || "-"}</div>
            </Tooltip>
          </div>
          <div className='quantity-type'>
            <div className="title">Quantity</div>
            <div className="desc">{request?.quantity || 1}</div>
          </div>
        </>
      )
    }
    if (type === CONSTANTS.MANAGED_EQUIPMENT) {
      return (
        <>
          <div className='vehicle-type managed-equipment'>
            <div className="title">Equipment Type</div>
            <div className="desc">{request?.equipmentType || "-"}</div>
          </div>
         { commonDivFunc()}
          <div className='description-type'>
            <div className="title">Description</div>
            <Tooltip content={request?.description || "-"} data-attribute="MyCart_Default_Tooltip_2">
              <div className="desc">{request?.description || "-"}</div>
            </Tooltip>
          </div>
          <div className='door-type price-managed'>
            <div className="title">Price</div>
            <div className="desc">{'$' + (formatPrice((request?.price || request?.pricePerUnit), 2)) || 0.00}</div>
          </div>
          <div className='quantity-type'>
            <div className="title">Quantity</div>
            <div className="desc">{request?.quantity || 1}</div>
          </div>
        </>
      )
    }
    if (type === CONSTANTS.NON_STANDARD_EQUIPMENT) {
      return (
        <>
          <div className='vehicle-type non-stan make-model'>
            <div className="title">Make & Model</div>
            <div className="desc">{request?.make || "-"} {request?.model || '-'}</div>
          </div>
          {commonDivFunc()}
          <div className='year-type'>
            <div className="title">Year</div>
            <div className="desc">{request?.year || "-"}</div>
          </div>
          <div className='vendor-type'>
            <div className="title">Dealer</div>
            <div className="desc">{request?.vendorName || "-"}</div>
              </div>
              <div className='quantity-type'>
                  <div className="title">Quantity</div>
                  <div className="desc">{request?.quantity || 1}</div>
              </div>
        </>
      )
    }
  }

  return (
    <div className="vehicle-request-data-container">
      <div className="header-container">
        <div className="heading">
          MY CART ({reasonCartList?.length})
        </div>
        <div className="expand-all">
            <Checkbox checked={requestExpand} className='me-1 mb-0' onChange={handleClickCheckbox} data-attribute="MyCart_Default_Checkbox_4" /><span className="expand-all-txt">Expand All</span>
            <span className='fa fa-angle-right'></span>
        </div>                   
      </div>
      <hr />
      {
        requestTypeList?.length ? requestTypeList.map((item: any, index: any) => (
          <div className="vehicle-request-data" key={index}>
            <div className="title-container">
              <div className="title">
                {item.requestType}
              </div>
              <div className="controls">
                <EventHandler onEvent={() => handleCollapseClick(index)} data-attribute={`MyCart_${(item?.requestType || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Toggle_EventHandler`}>
                  <div className={`${item.collapse == true ? 'up-image' : 'down-image'}`}>
                    <span></span>
                  </div>
                </EventHandler>
              </div>
            </div>
            {
              item.requestType === CONSTANTS.PRODUCTION_VEHICLE && item.collapse && productionCartVehicleList && productionCartVehicleList.map((request: any, index: any) => (
                <CartItems 
                  type={CONSTANTS.PRODUCTION_VEHICLE}
                  item={item} 
                  index={index} 
                  request={request} 
                  reasonCartList={reasonCartList} 
                  renderVehicleDetails={renderVehicleDetails} 
                  getExpand={getExpand} 
                  onClickDeleteReasonFromCart={onClickDeleteReasonFromCart} 
                  />
              ))
            }
            {
              item.requestType === CONSTANTS.MANAGED_EQUIPMENT && item.collapse && managedEquipmentCartList && managedEquipmentCartList.map((request: any, index: any) => (
                <CartItems 
                  type={CONSTANTS.MANAGED_EQUIPMENT}
                  item={item} 
                  index={index} 
                  request={request} 
                  reasonCartList={reasonCartList} 
                  renderVehicleDetails={renderVehicleDetails} 
                  getExpand={getExpand} 
                  onClickDeleteReasonFromCart={onClickDeleteReasonFromCart} 
                  />
              ))
            }
            {
              item.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT && item.collapse && nonStandardEquipmentCartList && nonStandardEquipmentCartList.map((request: any, index: any) => (
                <CartItems 
                  type={CONSTANTS.NON_STANDARD_EQUIPMENT}
                  item={item} 
                  index={index} 
                  request={request} 
                  reasonCartList={reasonCartList} 
                  renderVehicleDetails={renderVehicleDetails} 
                  getExpand={getExpand} 
                  onClickDeleteReasonFromCart={onClickDeleteReasonFromCart} 
                />
              ))
            }
            {
              item.requestType === CONSTANTS.MANAGEMENT_VEHICLE && item.collapse && managementVehicleCartList && managementVehicleCartList.map((request: any, index: any) => (
                <CartItems 
                  type={CONSTANTS.MANAGEMENT_VEHICLE}
                  item={item} 
                  index={index} 
                  request={request} 
                  reasonCartList={reasonCartList} 
                  renderVehicleDetails={renderVehicleDetails} 
                  getExpand={getExpand} 
                  onClickDeleteReasonFromCart={onClickDeleteReasonFromCart} 
                />
              ))
            }
          </div>
        )) : ""
      }

      {requestTypeList?.length > 0 ? (
        <div className="grand-order-container">
          <span>Order Grand Total</span>
          <span className='price'>
            {'$' + (formatPrice(grandTotal, 2))}
          </span>
        </div>
      ) : null}
      <div className="button-container">
        {
          (!isEditOrder || (orderByIdValue.orderStatusId == 2)) && <OutlineButton text='Cancel' onClick={handleClickCancel}  data-attribute="MyCart_Default_Button_8" />
        }
        {Popupcontent.isDialogVisible ? 
          <CancelConfirmationPopup
            hideDialog={!Popupcontent.isDialogVisible}
            onDismiss={hideDialog}
            Popupcontent={Popupcontent}
            popupOutlinebtnOnclick={() => Popupcontent.popupOutlinebtnOnclick()}
            popupPrimarybtnOnclick={() => Popupcontent.popupPrimarybtnOnclick()}
          /> : ""}
        {
          (!isEditOrder || (orderByIdValue.orderStatusId == 2)) && (
            <OutlineButton
              text='Save'
              disabled={
                !isCostCenterAvailableForSubmit ||
                (!isAuthorized(permissions.RequisitionsCreateUpdate) && !isAuthorized(permissions.CreateUpdateTransfers))
              }
              onClick={handleClickSave}
             data-attribute="MyCart_Default_Button_9" />
          )
        }
        <PrimaryButton
          text='Submit'
          disabled={
            !isCostCenterAvailableForSubmit ||
            (!isAuthorized(permissions.RequisitionsCreateUpdate) && !isAuthorized(permissions.CreateUpdateTransfers))
          }
          onClick={handleClickComplete}
         data-attribute="MyCart_Default_Button_10" />
      </div>
      {cancelPopupcontent.isDialogVisible &&
        <CompleteConfirmationPopup
          hideDialog={!cancelPopupcontent.isDialogVisible}
          onDismiss={hideDialogCancel}
          Popupcontent={cancelPopupcontent}
          popupOutlinebtnOnclick={() => cancelPopupcontent.popupOutlinebtnOnclick()}
          popupPrimarybtnOnclick={() => cancelPopupcontent.popupPrimarybtnOnclick()}
        />
      }
      {Popupcontent.isDialogVisible &&
        <CancelConfirmationPopup
          hideDialog={!Popupcontent.isDialogVisible}
          onDismiss={Popupcontent?.popupOutlinebtnOnclick ? Popupcontent?.popupOutlinebtnOnclick : hideDialog}
          Popupcontent={Popupcontent}
          popupOutlinebtnOnclick={() => Popupcontent.popupOutlinebtnOnclick()}
          popupPrimarybtnOnclick={() => Popupcontent.popupPrimarybtnOnclick()}
        />
      }
    </div>
  )
}
export default MyCart;
